import { render } from "./ProductRegistration.vue?vue&type=template&id=a4faaba4&scoped=true"
import script from "./ProductRegistration.vue?vue&type=script&lang=js"
export * from "./ProductRegistration.vue?vue&type=script&lang=js"

import "./ProductRegistration.vue?vue&type=style&index=0&id=a4faaba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4faaba4"]])

export default __exports__